<template>
    <div class="row">
        <div class="col">
            <search scope="mine"></search>
            <result :show-links="false"></result>
            <back-to-top></back-to-top>
        </div>
    </div>
</template>

<script>
    import Result from '../data/agents/Result'
    import Search from '../data/agents/Search'

    export default {
    
        components: {
            Search, Result
        }
    }
</script>
